import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function MidCTA() {
  return <section className="py-12 px-4" data-id="element-152">
      <div className="max-w-3xl mx-auto text-center" data-id="element-153">
        <p className="text-sm md:text-base text-primary font-bold uppercase tracking-wide mb-3" data-id="element-154">
          ⚠️ Antes que el cupo se cierre
        </p>
        <h3 className="text-2xl md:text-4xl font-extrabold text-white mb-6 leading-tight" data-id="element-155">
          Recuperá tus domingos.
          <br data-id="element-156" />
          Asegurá el precio de lanzamiento HOY.
        </h3>

        <motion.a href="#pricing" whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.98
      }} className="inline-flex items-center justify-center gap-2 bg-primary text-black font-space-grotesk font-extrabold text-base md:text-xl rounded-xl px-8 py-4 md:px-10 md:py-5 shadow-[0_0_30px_rgba(74,222,128,0.4)] hover:shadow-[0_0_45px_rgba(74,222,128,0.7)] hover:bg-primaryHover transition-colors duration-200" data-id="element-157">
          👉 SÍ, QUIERO VER LA OFERTA
          <ArrowDown className="w-5 h-5 animate-bounce" data-id="element-158" />
        </motion.a>

        <p className="text-xs text-zinc-500 mt-4" data-id="element-159">
          Más de 500 profes ya lo tienen · Garantía de 7 días
        </p>
      </div>
    </section>;
}